import { UserShape } from '_types/User';

export type ShopifyLanguages = 'NB' | 'EN';
export type ShopifyLanguageCodes = 'nb' | 'en';

export const getLanguageAndCurrencyConfig = (
    user?: Pick<UserShape, 'preferred_language' | 'country'>,
): { language: ShopifyLanguages; countryCode: string } => {
    const lang = user?.preferred_language;
    const countryCode = user?.country?.code || 'NO';
    return {
        language: lang === 'no' ? 'NB' : 'EN',
        countryCode,
    };
};
